import React from 'react';
import TextBlockBodyView from './text-block-body-view';

const TextBlockBodyContainer = ({
  title,
  text,
  onTitleChange,
  onTextChange,
}) => {
  return (
    <TextBlockBodyView
      title={title}
      text={text}
      onTitleChange={onTitleChange}
      onTextChange={onTextChange}
    />
  );
};

export default TextBlockBodyContainer;


